var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkPermi(["merchant:esign:contract:list"])
    ? _c(
        "div",
        { staticClass: "divBox" },
        [
          _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: "20px" },
              },
            },
            [
              _vm.pendingCount > 0
                ? _c("el-alert", {
                    staticClass: "mb15",
                    attrs: {
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                      title:
                        "平台发来 " +
                        _vm.pendingCount +
                        " 份合同待签署，请尽快由经办人完成签署",
                    },
                  })
                : _vm._e(),
              _c("el-alert", {
                staticClass: "mb15",
                attrs: {
                  type: "info",
                  closable: false,
                  title:
                    "平台在「腾讯电子签」发出合同，由经办人用登记的手机号在腾讯电子签完成签署，签完点「我已完成签署」，平台确认后可在此查看下载合同。",
                },
              }),
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "全部" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.query.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "status", $$v)
                            },
                            expression: "query.status",
                          },
                        },
                        _vm._l(_vm.statusMap, function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v.text, value: Number(k) },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "合同名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search($event)
                          },
                        },
                        model: {
                          value: _vm.query.keywords,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "keywords", $$v)
                          },
                          expression: "query.keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.list, size: "small", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "contractName",
                      label: "合同名称",
                      "min-width": "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "签署主体", "min-width": "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("div", [_vm._v(_vm._s(row.signerOrgName))]),
                              _c("div", { staticClass: "sub" }, [
                                _vm._v(
                                  "经办人：" +
                                    _vm._s(row.signerName) +
                                    " " +
                                    _vm._s(row.signerMobile)
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1675347325
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "small",
                                    type: (_vm.statusMap[row.status] || {}).tag,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.statusMap[row.status] || {}).text
                                    )
                                  ),
                                ]
                              ),
                              row.status === 1 && row.signerDone === 1
                                ? _c("div", { staticClass: "sub" }, [
                                    _vm._v("已反馈签完，等待平台确认"),
                                  ])
                                : row.flowMessage
                                ? _c("div", { staticClass: "sub" }, [
                                    _vm._v(_vm._s(row.flowMessage)),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      136151563
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "发起时间",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "finishTime",
                      label: "完成时间",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "200", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.status === 1 &&
                              _vm.checkPermi(["merchant:esign:contract:sign"])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.sign(row)
                                        },
                                      },
                                    },
                                    [_vm._v("去签署")]
                                  )
                                : _vm._e(),
                              row.status === 2
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.download(row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看合同")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      597197966
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-sizes": [20, 40, 60],
                      "page-size": _vm.query.limit,
                      "current-page": _vm.query.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": function (v) {
                        return (_vm.query.limit = v), _vm.getList()
                      },
                      "current-change": function (v) {
                        return (_vm.query.page = v), _vm.getList()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "在线签署",
                visible: _vm.signVisible,
                width: "440px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.signVisible = $event
                },
                closed: _vm.getList,
              },
            },
            [
              _c(
                "div",
                { staticClass: "sign-box" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.signUrl,
                        expression: "signUrl",
                      },
                    ],
                    ref: "qrcode",
                    staticClass: "qrcode",
                  }),
                  _vm.signRow
                    ? [
                        _vm.signUrl
                          ? _c("p", { staticClass: "sub" }, [
                              _vm._v(
                                "请经办人用手机微信扫码，在腾讯电子签中完成签署"
                              ),
                            ])
                          : _c("div", { staticClass: "guide" }, [
                              _c("p", [
                                _vm._v(
                                  "平台已在「腾讯电子签」发起合同，请经办人："
                                ),
                              ]),
                              _c("p", [
                                _vm._v("1. 打开微信，搜索小程序「"),
                                _c("b", [_vm._v("腾讯电子签")]),
                                _vm._v("」"),
                              ]),
                              _c("p", [
                                _vm._v("2. 用手机号 "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.signRow.signerMobile)),
                                ]),
                                _vm._v(" 登录，完成实名认证"),
                              ]),
                              _c("p", [
                                _vm._v(
                                  "3. 在「待我处理」中找到「" +
                                    _vm._s(_vm.signRow.contractName) +
                                    "」并签署"
                                ),
                              ]),
                            ]),
                      ]
                    : _vm._e(),
                  _vm.signUrl
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.openUrl },
                        },
                        [_vm._v("在电脑上打开签署页")]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.signVisible = false
                        },
                      },
                    },
                    [_vm._v("稍后签署")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.reportSigned },
                    },
                    [_vm._v("我已完成签署")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.previewTitle,
                visible: _vm.previewVisible,
                width: "80%",
                top: "4vh",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewVisible = $event
                },
                closed: _vm.revokePreview,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.previewLoading,
                      expression: "previewLoading",
                    },
                  ],
                  staticClass: "pdf-box",
                },
                [
                  _vm.previewBlobUrl
                    ? _c("iframe", {
                        staticClass: "pdf-frame",
                        attrs: { src: _vm.previewBlobUrl },
                      })
                    : _vm.previewError
                    ? _c("div", { staticClass: "pdf-error" }, [
                        _vm._v(_vm._s(_vm.previewError)),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.openPreviewNew },
                    },
                    [_vm._v("新窗口打开")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.previewVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }